import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  Input,
} from '@heroui/react';
import _ from 'lodash';
import { useEffect, useState } from 'react';

import { setUnitPref } from '@/patient-app-common/slices/appSlice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

export function WeightInput({ answerHistory, sendAnswer }) {
  const dispatch = useAppDispatch();
  let { unitPref } = useAppSelector(({ app }) => app);

  if (!unitPref) {
    unitPref = 'metric';
  }

  const [error, setError] = useState('');
  const [unit, setUnit] = useState(unitPref);
  const [answerInUnit, setAnswerInUnit] = useState('');

  useEffect(() => {
    if (!answerHistory) {
      return;
    }

    let parsedAnswer = answerHistory.toString();

    if (unitPref === 'imperial') {
      parsedAnswer = _.round(answerHistory * 2.205).toString();
    }

    setAnswerInUnit(parsedAnswer);
  }, [answerHistory]);

  const validateNumber = (e) => {
    const parsedAnswer = parseFloat(e.target.value);

    if (!Number.isFinite(parsedAnswer) || parsedAnswer < 0) {
      setError('Enter a valid number');
      return false;
    }

    return true;
  };

  const convertLBtoKG = (value) => {
    const kg = value * 0.45359237;
    return _.round(kg, 2);
  };

  const handleInput = (event) => {
    setError('');
    const { value } = event.target;
    const valid = validateNumber(event);

    if (!valid) {
      sendAnswer(null);
      return;
    }

    let answer;

    if (unit === 'imperial') {
      answer = convertLBtoKG(value).toString();
    } else {
      answer = _.round(value, 2).toString();
    }
    sendAnswer(answer);
  };

  const handleUnitChange = () => {
    sendAnswer(null);
    setAnswerInUnit('');

    if (unit === 'metric') {
      setUnit('imperial');
      dispatch(setUnitPref('imperial'));
    } else {
      setUnit('metric');
      dispatch(setUnitPref('metric'));
    }
  };

  const unitDisplay = unit === 'metric' ? 'kg' : 'lbs';

  return (
    <>
      <Card className="max-w-md">
        <CardBody>
          <Input
            color="primary"
            value={answerInUnit}
            endContent={
              <div className="flex items-center">
                <span>{unitDisplay}</span>
              </div>
            }
            errorMessage={error}
            isInvalid={!_.isEmpty(error)}
            onChange={(e) => handleInput(e)}
            size="lg"
            type="number"
            variant="underlined"
          />
        </CardBody>
        <CardFooter>
          <ButtonGroup>
            <Button
              color="primary"
              onPress={handleUnitChange}
              variant={unit === 'imperial' ? 'solid' : 'bordered'}
            >
              Pounds (lbs)
            </Button>
            <Button
              color="primary"
              onPress={handleUnitChange}
              variant={unit === 'metric' ? 'solid' : 'bordered'}
            >
              Kilograms (kg)
            </Button>
          </ButtonGroup>
        </CardFooter>
      </Card>
    </>
  );
}
